import { triggerAnalyticsEvent } from "../../lib";
import { Expando } from "slide-ui";

interface PhotoRequirementsProps {
  inErrorState?: boolean;
}

export function PhotoRequirements({ inErrorState = false }: PhotoRequirementsProps) {
  const title = "Photo Requirements";

  const onToggle = () => {
    // Include Analytics tracking here
    const linkCommunitySelectData = {
      event: "internal_link",
      event_action: "toggle_click",
      event_category: "internal_link",
      event_label: title,
      link_data_info: title,
      link_data_target: "internal_link",
      link_data_type: "toggle"
    };

    triggerAnalyticsEvent("internal_link_dl", linkCommunitySelectData);
  };

  const expandoContent = () => {
    return (
      <div className="photo_requirements__section">
        <div className="photo_requirements__subsection">
          Be modest
          <ul>
            <li>No photos in swimwear</li>
            <li>Be church appropriate</li>
            <li>No kissing</li>
          </ul>
        </div>
        <div className="photo_requirements__subsection">
          Keep it classy
          <ul>
            <li>No hats or sunglasses</li>
            <li>Good lighting</li>
            <li>Show us your smile</li>
          </ul>
        </div>
        <div className="photo_requirements__subsection">
          Culturally sensitive
          <ul>
            <li>Nothing that looks expensive</li>
            <li>No hand gestures</li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="photo-requirements">
      <Expando
        title={title}
        classList="panel panel-default"
        initialOpen={inErrorState}
        buttonCallback={onToggle}
      >
        {expandoContent()}
      </Expando>
    </div>
  );
}

export default PhotoRequirements;
